<template>
  <div color="primary">
    <v-btn v-for="(button, key) in buttons" :to="button.url" icon :key="key">
      <v-icon>{{ button.icon.menu }}</v-icon>
    </v-btn>
    <v-menu :nudge-bottom="40" left>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" v-on="{ ...tooltip, ...menu }" text rounded>
              <span>{{ language }}</span>
              <v-icon class="ml-2" x-small>{{ icon(attrs['aria-expanded']) }}</v-icon>
            </v-btn>
          </template>
          <span>{{ t({s:'changeLanguage', component: 'AppBar'}) }}</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in locales" :key="index" @click="changeLocale(item)">
          <v-list-item-title>
            <v-avatar color="white" class="mr-2" size="25">
              <v-img :src="item.icon"/>
            </v-avatar>
            {{ $vuetify.lang.t(`$vuetify.lang.${item.name}`) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-tooltip bottom>
      <template v-slot:activator="{on}">
        <v-btn v-on="on" icon color="white" @click="toggleNightMode">
            <v-icon>{{ $vuetify.theme.dark ? 'fa-light fa-sun-bright' : 'fal fa-moon' }}</v-icon>
        </v-btn>
      </template>
      <span>{{ t({s:'toggleNightmode', component: 'AppBar'}) }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{on}">
        <v-btn v-on="on" @click="logout" icon style="margin-right: -12px">
          <v-icon>fal fa-sign-out-alt</v-icon>
        </v-btn>
      </template>
      <span>{{ t({s:'logout', component: 'AppBar'}) }}</span>
    </v-tooltip>
  </div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import { mutations } from '../../state'

export default {
  name: 'TopRightButtons',
  data: () => ({
    buttons: []
  }),
  computed: {
    ...mapState(['locales', 'locale']),
    language () { return this.locale?.key || 'en' }
  },
  methods: {
    icon (expanded) {
      if (expanded === 'true') {
        return 'fal fa-chevron-down fa-rotate-180'
      }
      return 'fal fa-chevron-down'
    },
    toggleNightMode () {
      mutations.toggleNightMode()
    },
    async changeLocale (lang) {
      await this.$store.dispatch('setLocale', { lang })
    },
    async logout () {
      if (this.$auth) {
        this.$auth.logout()
      }
    }
  },
  watch: {
    locale (lang) {
      if (lang) {
        this.$moment.locale(lang.key)
        this.$vuetify.lang.current = lang.key
      }
    }
  }
}
</script>

<style scoped>

</style>
